import { createSelector } from '@ngrx/store'
import { sortByProp } from 'globals/helpers/helpers'
import { contactsStateSelector } from '../contacts.era'
import { workforceStateSelector } from '../workforce.era'

const contactEntities = createSelector(contactsStateSelector, (state) => state.entities)
const workersByEmail = createSelector(workforceStateSelector, (state) => state.workersByEmail)

export const contactListSelector = createSelector(contactEntities,(contacts)=> {
  const contactList = Object.values(contacts) 
  contactList.sort(sortByProp('displayName'))
  return contactList
})


export const possibleContactsSelector = createSelector(
  contactListSelector,
  workersByEmail,
  (contactList, workersByEmail) => { 
    // console.log({ contactList, workersByEmail })
    if (!contactList) return []
    if (!workersByEmail) return [...contactList]
    return contactList.filter(c => !workersByEmail[c.email])
  }
)

